/* unplugin-vue-components disabled */import { render } from "./AppLayout.vue?vue&type=template&id=af832bbe&scoped=true"
import script from "./AppLayout.vue?vue&type=script&lang=js"
export * from "./AppLayout.vue?vue&type=script&lang=js"

import "./AppLayout.vue?vue&type=style&index=0&id=af832bbe&scoped=true&lang=scss"
import "./AppLayout.vue?vue&type=style&index=1&id=af832bbe&scoped=global&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af832bbe"]])

export default __exports__